import "./Checkbox.scss";

import { Checkbox as MUICheckbox, CheckboxProps as MUICheckboxProps, FormControlLabel, Typography } from "@material-ui/core";
import React from "react";

export interface CheckboxProps extends MUICheckboxProps {
  error: any;
  label: React.ReactNode;
}

export const Checkbox = (props: CheckboxProps) => {
  // Props
  const {
    className,
    disabled,
    error,
    id,
    label,
    value,
  } = props;

  // Options
  const errorExtension = error ? "error" : "";
  const checkboxClassName = className ? className + (errorExtension ? "--" + errorExtension : "") : errorExtension;

  return (
    <FormControlLabel
      className={"common-checkbox " + checkboxClassName}
      control={
        <MUICheckbox
          {...props}
          indeterminate={!disabled && value === null}
          name={id}
          color="primary"
        />
      }
      label={<Typography>{label}</Typography>}
    />
  );
};
